import { useRef } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { apiBaseUrl } from '@/shared/api/axios-instance';
import { useOpenedPopupsValue, useSetOpenedPopupsState } from '@/shared/atoms/opened-popups';
import BookingForm from '@/shared/components/configurator/BookingForm';
import CloseButton from '@/shared/components/configurator/CloseButton';
import StreetGallery from '@/shared/components/configurator/StreetGallery';
import Popup from '@/shared/components/shared/Popup';
import { useMounted } from '@/shared/hooks/use-mounted';
import { useTypograf } from '@/shared/hooks/use-typograf';

export const STREET_EXPOSITION_NAME = 'street-exposition';

const RightBlock = () => {
    const responseRoot = useRef<HTMLDivElement>(null);
    const title = useTypograf('Заявка на бронирование площади');
    const description = useTypograf(
        ' Оставьте свои данные и команда TNF свяжется с вами, чтобы обсудить дизайн и ваши бизнес-задачи на EXPO',
    );

    return (
        <>
            <StreetGallery />
            <div className="street-page-right">
                <div ref={responseRoot} className="street-page-right-inner">
                    <div className="booking-form__top">
                        <div className="booking-form__top-left">
                            <div className="booking-form__title text-l">{title}</div>
                            <p className="booking-form__description text-s">{description}</p>
                        </div>
                    </div>
                    <BookingForm
                        responseRoot={responseRoot}
                        apiEndpoint={`${apiBaseUrl}/v1/feedback/constructor/outside`}
                        additionalData={{ form_type: 'Форма уличной экспозиции' }}
                    />
                </div>
            </div>
        </>
    );
};

const StreetExpositionPopup = () => {
    const { closePopup } = useSetOpenedPopupsState();
    const openedPopups = useOpenedPopupsValue();
    const isOpened = openedPopups.includes(STREET_EXPOSITION_NAME);
    const isTablet = useMediaQuery('(max-width: 1199px)');
    const isMounted = useMounted();

    return (
        <Popup
            name={STREET_EXPOSITION_NAME}
            className="constructor-popup street-exposition-popup"
            data-popup-preset="default"
            wrapperSlot={!isTablet && isMounted && <RightBlock />}
        >
            {isOpened && (
                <>
                    <div className="page-top street-page-top">
                        <div className="h3">Уличная экспозиция</div>
                        <CloseButton
                            text="К расположению"
                            className="page-top__close-btn"
                            onClick={() => {
                                closePopup(STREET_EXPOSITION_NAME);
                            }}
                        />
                    </div>
                    <div className="street-page-content">
                        <div className="street-page-content__table">
                            <table className="data-table">
                                <tbody>
                                    <tr>
                                        <td>Площадь от</td>
                                        <td>
                                            (20 м<sup>2</sup>)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Цена</td>
                                        <td>по запросу</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="street-map-wrapper">
                            <picture>
                                <source media="(max-width: 767px)" srcSet="/img/street-map-mobile.svg" />
                                <img
                                    src="/img/street-map.svg"
                                    width="1"
                                    height="1"
                                    className="img-fluid street-map"
                                    alt=""
                                    loading="lazy"
                                    decoding="async"
                                />
                            </picture>
                        </div>

                        {isTablet && isMounted && <RightBlock />}
                    </div>
                </>
            )}
        </Popup>
    );
};

export default StreetExpositionPopup;
